import {
  Box,
  CircularProgress,
  Divider,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@mui/material";
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { callAPI, formatIndianCurrency, getLocalValue, LoacalVariables, Method, toBoolean } from "../../commonFunctions/CommonFunctions";
import WSButton from "../../Components/Button/WSButton";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { NotFound } from "../NotFound";
import logo from '../../images/logo.svg'
import { IBranch } from "../DTO/Dto";
const OrderPrint = () => {
  const { id } = useParams();
  const { showMessage } = useSnackbar();

  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [branchData, setBranchData] = useState<IBranch>();
  const [paymentData, setPaymentData] = useState<any>();
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    async function getDataById() {
      try {
        const response: any = await callAPI("workorders", Method.GET, null, id);
        console.log("response is", response)
        if (response?.data) {
          setData(response.data);
        }
      } catch (error) {
        showMessage("Something went wrong. Please try again.", "error");
      } finally {
        setLoading(false);
      }
    }
    async function getBranchDetails() {
      try {
        const response: any = await callAPI("Branch", Method.GET, null, getLocalValue(LoacalVariables.Branch));
        if (response?.data) {
          setBranchData(response.data);
        }
      } catch (error) {
        showMessage("Something went wrong. Please try again.", "error");
      } finally {
        setLoading(false);
      }
    }

    async function getPayments() {
      try {
        const response: any = await callAPI("payment-receives/work-order", Method.GET, null, id);
        console.log('response is,', response);
        if (response?.data) {
          setPaymentData(response.data[0]);
        }
      } catch (error) {
        showMessage("Something went wrong. Please try again.", "error");
      } finally {
        setLoading(false);
      }
    }

    if (id) {
      getDataById();
      getBranchDetails();
      getPayments();
    }
  }, [id]);


  //  Print Handler
  const handlePrint = useReactToPrint({
    contentRef
  });
  const totalAmount = data?.quotationItems
    .reduce((sum: number, item: any) => sum + Number(item.quantity * item.unitPrice || 0), 0)
    .toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  if (loading)
    return (
      <Box display="flex" justifyContent="center" mt={4}>
        <CircularProgress />
      </Box>
    );
  if (!data) return <NotFound />;

  const totalInluded = data.quotationItems
    .filter((item: any) => item.isIncluded)
    .reduce((sum: number, item: any) => sum + Number(item.unitPrice * item?.quantity), 0)
    .toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  const totalExcluded = data.quotationItems
    .filter((item: any) => !item.isIncluded)
    .reduce((sum: number, item: any) => sum + Number(item.unitPrice * item?.quantity), 0)
    .toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })

  return (
    <div>
      <WSButton
        id="printBtn"
        label="Print Order"
        variant="contained"
        color="primary"
        onClick={handlePrint}
        size="small"
        sx={{ marginBottom: 2 }}
      />
      <Paper
        ref={contentRef}
        style={{
          padding: "40px 50px",
          width: "210mm",
          minHeight: "297mm",
          margin: "auto",
          boxSizing: "border-box",
          fontFamily: "'Times New Roman', serif"
        }}
      >
        {/* Header Section */}
        <Box sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          marginBottom: 3,
          borderBottom: "2px solid #333",
          paddingBottom: 2
        }}>
          <Box sx={{ width: "120px", flexShrink: 0 }}>
            <img
              src={logo}
              alt="Company Logo"
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "80px",
                objectFit: "contain"
              }}
            />
          </Box>

          <Box sx={{ textAlign: "center", flexGrow: 1, mx: 3 }}>
            <Typography variant="h4" fontWeight="bold" color="error" fontStyle="italic" sx={{ mb: 1 }}>
              {branchData?.name}
            </Typography>
            <Typography sx={{ fontWeight: "bold", fontSize: '1rem' }}>
              {branchData?.address?.addressLine1} P.O {branchData?.address?.pincode}
            </Typography>
            {branchData?.address?.addressLine2 &&
              branchData.address.addressLine2 !== 'null' && (
                <Typography sx={{ fontWeight: "bold", fontSize: '1rem' }}>
                  {branchData.address.addressLine2}
                </Typography>
              )}
          </Box>

          {/* Contact Details */}
          <Box sx={{ textAlign: "right", width: "120px", flexShrink: 0 }}>
            <Typography sx={{ fontWeight: "bold", fontSize: '0.9rem', mb: 0.5 }}>
              📞 {branchData?.phoneNumber}
            </Typography>
            {branchData?.alternatePhoneNumber && (
              <Typography sx={{ fontWeight: "bold", fontSize: '0.9rem' }}>
                📞 {branchData?.alternatePhoneNumber}
              </Typography>
            )}
          </Box>
        </Box>

        {/* Order Form Title */}
        <Box sx={{
          textAlign: "center",
          marginBottom: 3,
          border: "2px solid #333",
          padding: 2,
          backgroundColor: "#f8f8f8"
        }}>
          <Typography variant="h4" sx={{ fontWeight: "bold", fontSize: '1.4rem' }}>
            ORDER FORM
          </Typography>
          <Typography sx={{ fontSize: '1rem', mt: 1 }}>
            Date: {dayjs(data?.date).format("DD/MM/YYYY")}
          </Typography>
        </Box>

        {/* Client & Order Details */}
        <TableContainer sx={{ mb: 3 }}>
          <Table size="medium" sx={{ border: "1px solid #ddd" }}>
            <TableBody>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold", fontSize: '0.9rem', width: "30%", backgroundColor: "#f5f5f5" }}>
                  Name of Client
                </TableCell>
                <TableCell sx={{ fontSize: '0.9rem' }}>{data?.customerName || "N/A"}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold", fontSize: '0.9rem', backgroundColor: "#f5f5f5" }}>Address</TableCell>
                <TableCell sx={{ fontSize: '0.9rem' }}>{data?.address || "N/A"}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold", fontSize: '0.9rem', backgroundColor: "#f5f5f5" }}>Phone</TableCell>
                <TableCell sx={{ fontSize: '0.9rem' }}>{data?.phone || "N/A"}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold", fontSize: '0.9rem', backgroundColor: "#f5f5f5" }}>
                  Approximate Area
                </TableCell>
                <TableCell sx={{ fontSize: '0.9rem' }}>{data?.approximateArea || "N/A"}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold", fontSize: '0.9rem', backgroundColor: "#f5f5f5" }}>Estimation Amount</TableCell>
                <TableCell sx={{ fontSize: '0.9rem', fontWeight: "bold", color: "#2e7d32" }}>
                  {/* ₹{Number(data?.rate).toFixed(2) || "0.00"} */}
                  ₹ {formatIndianCurrency(totalInluded)}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold", fontSize: '0.9rem', backgroundColor: "#f5f5f5" }}>
                  Date of Commencement
                </TableCell>
                <TableCell sx={{ fontSize: '0.9rem' }}>
                  {dayjs(data?.commencement).format("DD/MM/YYYY")}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold", fontSize: '0.9rem', backgroundColor: "#f5f5f5" }}>
                  Date of Completion
                </TableCell>
                <TableCell sx={{ fontSize: '0.9rem' }}>
                  {dayjs(data?.completion).format("DD/MM/YYYY")}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        {/* Included Items Table */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1, fontSize: '1.1rem', color: "#2e7d32" }}>
            WORK INCLUDED
          </Typography>
          <TableContainer component={Paper} sx={{ border: "1px solid #2e7d32" }}>
            <Table size="medium">
              <TableHead>
                <TableRow sx={{ bgcolor: '#2e7d32' }}>
                  <TableCell sx={{ fontWeight: 700, color: 'white', fontSize: '0.9rem', width: "50%" }}>
                    PARTICULAR
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: 700, color: 'white', fontSize: '0.9rem', width: "15%" }}>
                    QTY/Sqft
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: 700, color: 'white', fontSize: '0.9rem', width: "15%" }}>
                    RATE
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: 700, color: 'white', fontSize: '0.9rem', width: "20%" }}>
                    AMOUNT
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.quotationItems
                  .filter((item: any) => item.isIncluded)
                  .map((item: any, index: number) => (
                    <TableRow key={index}>
                      <TableCell sx={{ fontSize: '0.85rem' }}>
                        {item.productName}
                        {item.isPolish !== '2' && (
                          <> ({toBoolean(item.isPolish) ? 'With Polish' : 'Without Polish'})</>
                        )} ({item?.unit})
                      </TableCell>
                      <TableCell align="center" sx={{ fontSize: '0.85rem' }}>{item.quantity}</TableCell>
                      <TableCell align="center" sx={{ fontSize: '0.85rem' }}>
                        ₹{Number(item.unitPrice).toFixed(2)}
                      </TableCell>
                      <TableCell align="center" sx={{ fontSize: '0.85rem', fontWeight: 500 }}>
                        ₹{Number(item.unitPrice * item.quantity).toFixed(2)}
                      </TableCell>
                    </TableRow>
                  ))}

                {/* TOTAL row */}
                <TableRow sx={{ borderTop: "2px solid #2e7d32" }}>
                  <TableCell colSpan={3} align="right" sx={{ fontWeight: 900, fontSize: '0.9rem', color: '#2e7d32' }}>
                    TOTAL INCLUDED:
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: 900, fontSize: '0.9rem', color: '#2e7d32' }}>
                    {totalInluded ? formatIndianCurrency(totalInluded) : '0.00'}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        {/* Excluded Items Table */}
        {data.quotationItems.filter((item: any) => !item.isIncluded).length > 0 && (
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1, fontSize: '1.1rem', color: "#d32f2f" }}>
              WORK EXCLUDED
            </Typography>
            <TableContainer component={Paper} sx={{ border: "1px solid #d32f2f" }}>
              <Table size="medium">
                <TableHead>
                  <TableRow sx={{ bgcolor: '#d32f2f' }}>
                    <TableCell sx={{ fontWeight: 700, color: 'white', fontSize: '0.9rem', width: "50%" }}>
                      PARTICULAR
                    </TableCell>
                    <TableCell align="center" sx={{ fontWeight: 700, color: 'white', fontSize: '0.9rem', width: "15%" }}>
                      QTY/Sqft
                    </TableCell>
                    <TableCell align="center" sx={{ fontWeight: 700, color: 'white', fontSize: '0.9rem', width: "15%" }}>
                      RATE
                    </TableCell>
                    <TableCell align="center" sx={{ fontWeight: 700, color: 'white', fontSize: '0.9rem', width: "20%" }}>
                      AMOUNT
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.quotationItems
                    .filter((item: any) => !item.isIncluded)
                    .map((item: any, index: number) => (
                      <TableRow key={index}>
                        <TableCell sx={{ fontSize: '0.85rem' }}>{item.productName} ({item?.unit})</TableCell>
                        <TableCell align="center" sx={{ fontSize: '0.85rem' }}>{item.quantity}</TableCell>
                        <TableCell align="center" sx={{ fontSize: '0.85rem' }}>
                          ₹{Number(item.unitPrice).toFixed(2)}
                        </TableCell>
                        <TableCell align="center" sx={{ fontSize: '0.85rem', fontWeight: 500 }}>
                          ₹{Number(item.unitPrice * item.quantity).toFixed(2)}
                        </TableCell>
                      </TableRow>
                    ))}

                  {/* TOTAL row */}
                  <TableRow sx={{ borderTop: "2px solid #d32f2f" }}>
                    <TableCell colSpan={3} align="right" sx={{ fontWeight: 900, fontSize: '0.9rem', color: '#d32f2f' }}>
                      TOTAL EXCLUDED:
                    </TableCell>
                    <TableCell align="center" sx={{ fontWeight: 900, fontSize: '0.9rem', color: '#d32f2f' }}>
                      {totalExcluded ? formatIndianCurrency(totalExcluded) : '0.00'}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}

        {/* Grand Total */}
        <Box sx={{ mb: 3 }}>
          <TableContainer component={Paper} sx={{ border: "2px solid #00A300" }}>
            <Table size="medium">
              <TableHead>
                <TableRow sx={{ bgcolor: '#00A300' }}>
                  <TableCell colSpan={4} sx={{ fontWeight: 900, color: 'white', fontSize: '1rem', textAlign: "center" }}>
                    GRAND TOTAL
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell colSpan={4} sx={{ textAlign: "center", py: 2 }}>
                    <Typography variant="h5" sx={{ fontWeight: 900, color: '#00A300', fontSize: '1.3rem' }}>
                      {/* {formatIndianCurrency(totalInluded)} */}
                      ₹ {totalAmount ? formatIndianCurrency(totalAmount) : '0.00'}
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        {/* Terms and Conditions */}
        {data.termsAndConditions !== "" && (
          <Box sx={{ mb: 3, breakInside: 'avoid' }}>
            <Typography sx={{ fontWeight: 700, mb: 1, fontSize: '0.9rem', color: "#333" }}>
              Terms and Conditions:
            </Typography>
            <Box sx={{
              pl: 2,
              fontSize: '0.85rem',
              whiteSpace: 'pre-line',
              borderLeft: "3px solid #666",
              backgroundColor: "#f9f9f9",
              padding: 2,
              borderRadius: 1
            }}>
              {data.termsAndConditions}
            </Box>
          </Box>
        )}

        {/* Payment Terms */}
        {data?.paymentTerms?.length > 0 && (
          <Box sx={{ mb: 3, breakInside: 'avoid' }}>
            <Typography sx={{ fontWeight: 700, mb: 1, fontSize: '0.9rem', color: "#333" }}>
              Mode of Payment:
            </Typography>
            <Box sx={{
              pl: 2,
              backgroundColor: "#f9f9f9",
              padding: 2,
              borderRadius: 1
            }}>
              {data?.paymentTerms?.map((item: any, idx: number) => (
                <Typography
                  key={idx}
                  sx={{ marginBottom: 1, fontSize: '0.85rem', pl: 2 }}
                >
                  <strong>{item?.percentage}%</strong> - {item?.description}
                </Typography>
              ))}
            </Box>
          </Box>
        )}

        {paymentData && <Box sx={{ mb: 3 }}>
          <Typography sx={{ fontWeight: 700, mb: 1, fontSize: '0.9rem', color: "#333" }}>
            Payment:
          </Typography>
          <Box sx={{
            pl: 2,
            fontSize: '0.85rem',
            backgroundColor: "#f9f9f9",
            padding: 2,
            borderRadius: 1,
            minHeight: "20px"
          }}>
            We hereby confirm that an advance payment of ₹
            <span style={{ fontWeight: "bold" }}>{paymentData.amountReceived} </span>
            has been received from the Client on
            <span style={{ fontWeight: "bold" }}>{' ' + dayjs(paymentData.paymentDate).format("DD MMM YYYY") + ' '}</span>
            towards the execution of this Work Order. This amount has been duly acknowledged and will be adjusted against the total project value.
          </Box>
        </Box>}

        {/* Remarks */}
        <Box sx={{ mb: 3 }}>
          <Typography sx={{ fontWeight: 700, mb: 1, fontSize: '0.9rem', color: "#333" }}>
            Remarks:
          </Typography>
          <Box sx={{
            pl: 2,
            fontSize: '0.85rem',
            backgroundColor: "#f9f9f9",
            padding: 2,
            borderRadius: 1,
            minHeight: "40px"
          }}>
            {data?.remarks || "N/A"}
          </Box>
        </Box>

        {/* Footer */}
        <Box sx={{
          borderTop: "2px solid #333",
          paddingTop: 3,
          marginTop: 4,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start"
        }}>
          <Box sx={{ flex: 1 }}>
            <Typography fontWeight="bold" sx={{ fontSize: '0.9rem', mb: 1 }}>Accepted:</Typography>
            <Typography sx={{ fontSize: '0.85rem', mb: 2 }}>Name of Client: ___________________</Typography>
            <Typography sx={{ fontSize: '0.85rem', mb: 1 }}>Witnesses:</Typography>
            <Typography sx={{ fontSize: '0.85rem' }}>1. ___________________</Typography>
            <Typography sx={{ fontSize: '0.85rem' }}>2. ___________________</Typography>
          </Box>

          <Box sx={{ flex: 1, textAlign: "right" }}>
            <Typography sx={{ fontSize: '0.85rem', mb: 1 }}>Thanks & Regards,</Typography>
            <Typography fontWeight="bold" sx={{ fontSize: '0.9rem', mb: 0.5 }}>JOSEPH PJ</Typography>
            <Typography sx={{ fontSize: '0.85rem' }}>Managing Director</Typography>
          </Box>
        </Box>
      </Paper>
    </div>
  );
};

export default OrderPrint;
